// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"styles_swiperContainer__x2ss4","swiper":"styles_swiper__3si3i"};